import axios from 'axios';
import CryptoJS from 'crypto-js';
import { saveAs } from 'file-saver';
import { API_BASE_URL } from '@config';
import { showMessage } from 'app/store/actions';
import * as ActionsDialog from 'app/store/actions';
import { IMAGE_TYPE } from 'app/main/util/enums';
import store from 'app/store';

export const SET_OS_TYPES = 'SET_OS_TYPES';
export const setProviderOsTypes = os_types => ({
	type: SET_OS_TYPES,
	payload: os_types
});
// SET
export const SET_CLUSTER = 'SET_CLUSTER';
export const setCluster = cluster => ({
	type: SET_CLUSTER,
	payload: cluster
});

export const SET_MARKET_CLUSTER = 'SET_CLUSTER';
export const setMarketCluster = cluster => ({
	type: SET_CLUSTER,
	payload: cluster
});

export const SET_CLUSTERS_LIST = 'SET_CLUSTERS_LIST';
export const setClustersList = clusters => ({
	type: SET_CLUSTERS_LIST,
	payload: clusters
});

export const SET_CLUSTER_ACTIVITIES = 'SET_CLUSTER_ACTIVITIES';
export const setClusterActivities = cluster => ({
	type: SET_CLUSTER_ACTIVITIES,
	payload: cluster
});

export const SET_CLUSTER_TOKEN = 'SET_CLUSTER_TOKEN';
export const setClusterToken = token => ({
	type: SET_CLUSTER_TOKEN,
	payload: token
});

export const SET_LOGS = 'SET_LOGS';
export const setLogs = (logs, clusterId = null) => ({
	type: SET_LOGS,
	payload: { logs, clusterId }
});
export const SET_LOG_URLS = 'SET_LOG_URLS';
export const setLogURLs = links => ({
	type: SET_LOG_URLS,
	payload: links
});

export const SET_GPU_METRICS = 'SET_GPU_METRICS';
export const setGpuMetrics = metrics => ({
	type: SET_GPU_METRICS,
	payload: metrics
});

export const SET_GPU_METRICS_SUMMARY = 'SET_GPU_METRICS_SUMMARY';
export const setGpuMetricsSummary = summary => ({
	type: SET_GPU_METRICS_SUMMARY,
	payload: summary
});

export const SET_GPU_METRICS_LOADING = 'SET_GPU_METRICS_LOADING';
export const setGpuMetricsLoading = loading => ({
	type: SET_GPU_METRICS_LOADING,
	payload: loading
});

export const SET_GPU_METRICS_ERROR = 'SET_GPU_METRICS_ERROR';
export const setGpuMetricsError = error => ({
	type: SET_GPU_METRICS_ERROR,
	payload: error
});

export const SET_NODE = 'SET_NODE';
export const setNode = node => ({
	type: SET_NODE,
	payload: node
});

export const SET_SELECTED = 'SET_SELECTED';
export const setSelected = cluster => ({
	type: SET_SELECTED,
	payload: cluster
});

export const SET_CLUSTER_ERROR = 'SET_CLUSTER_ERROR';
export const setClusterError = error => ({
	type: SET_CLUSTER_ERROR,
	payload: error
});

export const SET_TAB_VALUE = 'SET_TAB_VALUE';
export const setTabValue = tabValue => ({
	type: SET_TAB_VALUE,
	payload: tabValue
});

export const SET_AI_ERROR_ANALYSIS = 'SET_AI_ERROR_ANALYSIS';
export const setAiErrorAnalysis = analysis => ({
	type: SET_AI_ERROR_ANALYSIS,
	payload: analysis
});

export const SET_CLUSTERS_SEARCH_TEXT = 'SET_CLUSTERS_SEARCH_TEXT';
export const setClustersSearchText = event => ({
	type: SET_CLUSTERS_SEARCH_TEXT,
	searchText: event.target.value
});

export const SET_FILTER = 'SET_FILTER';
export const setFilter = filter => ({
	type: SET_FILTER,
	payload: filter
});

// Feature: cluster-tags - Quick filters and org tags
export const SET_QUICK_FILTERS = 'SET_QUICK_FILTERS';
export const setQuickFilters = filters => ({
	type: SET_QUICK_FILTERS,
	payload: filters
});

export const SET_ORG_TAGS = 'SET_ORG_TAGS';
export const setOrgTags = tags => ({
	type: SET_ORG_TAGS,
	payload: tags
});

export const SET_CLUSTER_OPTIMISTIC_STATE = 'SET_CLUSTER_OPTIMISTIC_STATE';
export const setClusterOptimisticState = (clusterId, state) => ({
	type: SET_CLUSTER_OPTIMISTIC_STATE,
	payload: { clusterId, state }
});

export const fetchOrgTags = () => dispatch => {
	axios.get(API_BASE_URL + '/api/clusters/tags')
		.then(function (res) {
			dispatch(setOrgTags(res.data || []));
		})
		.catch(function () {
			dispatch(setOrgTags([]));
		});
};

// Update tags on a cluster (works in any state)
export const updateClusterTags = (clusterId, tags) => dispatch => {
	return axios.put(API_BASE_URL + '/api/clusters/' + clusterId + '/tags', { tags: tags }, headers)
		.then(function (res) {
			// Refresh cluster list to show updated tags
			dispatch(getClusters());
			// Refresh org tags autocomplete
			dispatch(fetchOrgTags());
			return res.data;
		});
};

export const SET_CLUSTER_HEALTH_DATA = 'SET_CLUSTER_HEALTH_DATA';
export const setClusterHealthData = healthData => ({
	type: SET_CLUSTER_HEALTH_DATA,
	payload: healthData
});

export const SET_CLUSTER_HEALTH_LOADING = 'SET_CLUSTER_HEALTH_LOADING';
export const setClusterHealthLoading = loading => ({
	type: SET_CLUSTER_HEALTH_LOADING,
	payload: loading
});

export const SET_CLUSTER_METRICS = 'SET_CLUSTER_METRICS';
export const setClusterMetrics = metrics => ({
	type: SET_CLUSTER_METRICS,
	payload: metrics
});

export const SET_CLUSTER_METRICS_HISTORY = 'SET_CLUSTER_METRICS_HISTORY';
export const setClusterMetricsHistory = history => ({
	type: SET_CLUSTER_METRICS_HISTORY,
	payload: history
});

export const SET_CLUSTER_METRICS_LOADING = 'SET_CLUSTER_METRICS_LOADING';
export const setClusterMetricsLoading = loading => ({
	type: SET_CLUSTER_METRICS_LOADING,
	payload: loading
});

export const SET_CLUSTER_METRICS_ERROR = 'SET_CLUSTER_METRICS_ERROR';
export const setClusterMetricsError = error => ({
	type: SET_CLUSTER_METRICS_ERROR,
	payload: error
});

export const SET_STRESS_TEST_DATA = 'SET_STRESS_TEST_DATA';
export const setStressTestData = data => ({
	type: SET_STRESS_TEST_DATA,
	payload: data
});

export const SET_STRESS_TEST_LOADING = 'SET_STRESS_TEST_LOADING';
export const setStressTestLoading = loading => ({
	type: SET_STRESS_TEST_LOADING,
	payload: loading
});

export const SET_STRESS_TEST_ERROR = 'SET_STRESS_TEST_ERROR';
export const setStressTestError = error => ({
	type: SET_STRESS_TEST_ERROR,
	payload: error
});

export const SET_CLUSTER_VOLUMES = 'SET_CLUSTER_VOLUMES';
export const setClusterVolumes = volumes => ({
	type: SET_CLUSTER_VOLUMES,
	payload: volumes
});

export const SET_PRECONFIGURED_DEVICES = 'SET_PRECONFIGURED_DEVICES';
export const setPreconfiguredDevices = devices => ({
	type: SET_PRECONFIGURED_DEVICES,
	payload: devices
});

export const SET_STRESS_TEST_HISTORY = 'SET_STRESS_TEST_HISTORY';
export const setStressTestHistory = history => ({
	type: SET_STRESS_TEST_HISTORY,
	payload: history
});

// CLEAR
export const CLEAR_CLUSTER = 'CLEAR_CLUSTER';
export const clearCluster = () => ({
	type: CLEAR_CLUSTER
});

export const CLEAR_CLUSTER_REDUCER = 'CLEAR_CLUSTER_REDUCER';
export const clearClusterReducer = () => ({
	type: CLEAR_CLUSTER_REDUCER
});

export const CLEAR_CLUSTER_LIST = 'CLEAR_CLUSTER_LIST';
export const clearClusterList = () => ({
	type: CLEAR_CLUSTER_LIST
});

export const CLEAR_LOGS = 'CLEAR_LOGS';
export const clearLogs = () => ({
	type: CLEAR_LOGS
});

export const CLEAR_AI_ERROR_ANALYSIS = 'CLEAR_AI_ERROR_ANALYSIS';
export const clearAiErrorAnalysis = (clusterId = null) => dispatch => {
	// Clear from Redux state
	dispatch({
		type: CLEAR_AI_ERROR_ANALYSIS
	});
	
	// Clear from localStorage
	try {
		if (clusterId) {
			// Clear specific cluster cache
			const cacheKey = `ai_analysis_${clusterId}`;
			localStorage.removeItem(cacheKey);
		} else {
			// Clear all AI analysis cache
			const keysToRemove = [];
			for (let i = 0; i < localStorage.length; i++) {
				const key = localStorage.key(i);
				if (key && key.startsWith('ai_analysis_')) {
					keysToRemove.push(key);
				}
			}
			keysToRemove.forEach(key => localStorage.removeItem(key));
		}
	} catch (err) {
		console.warn(err);
	}
};

export const CLEAR_CLUSTER_HEALTH_DATA = 'CLEAR_CLUSTER_HEALTH_DATA';
export const clearClusterHealthData = () => ({
	type: CLEAR_CLUSTER_HEALTH_DATA
});

export const CLEAR_CLUSTER_METRICS = 'CLEAR_CLUSTER_METRICS';
export const clearClusterMetrics = () => ({
	type: CLEAR_CLUSTER_METRICS
});

export const CLEAR_ERROR = 'CLEAR_ERROR';
export const clearError = () => ({
	type: CLEAR_ERROR
});

// * ////////////// INSTANCE AVAILABILITY ////////////// * //

export const SET_ZONE_AVAILABILITY = 'SET_ZONE_AVAILABILITY';
export const setZoneAvailability = (data) => ({
	type: SET_ZONE_AVAILABILITY,
	payload: data
});

export const SET_ZONE_AVAILABILITY_LOADING = 'SET_ZONE_AVAILABILITY_LOADING';
export const setZoneAvailabilityLoading = (loading) => ({
	type: SET_ZONE_AVAILABILITY_LOADING,
	payload: loading
});

export const SET_ZONE_AVAILABILITY_ERROR = 'SET_ZONE_AVAILABILITY_ERROR';
export const setZoneAvailabilityError = (error) => ({
	type: SET_ZONE_AVAILABILITY_ERROR,
	payload: error
});

export const CLEAR_ZONE_AVAILABILITY = 'CLEAR_ZONE_AVAILABILITY';
export const clearZoneAvailability = () => ({
	type: CLEAR_ZONE_AVAILABILITY
});

// * ////////////// AWS LIVE CATALOG ////////////// * //
// The AWS cluster form is credential-first and reads everything live from
// AWS: regions for the credential, then zones / shapes / per-zone offerings /
// prices for the region. Nothing is cached, on purpose. Every request carries
// a requestKey so a slow response for a selection the user has already moved
// away from is dropped instead of overwriting the current one.

export const AWS_REGIONS_LOADING = 'AWS_REGIONS_LOADING';
export const AWS_REGIONS_LOADED = 'AWS_REGIONS_LOADED';
export const AWS_REGIONS_FAILED = 'AWS_REGIONS_FAILED';
export const AWS_CATALOG_LOADING = 'AWS_CATALOG_LOADING';
export const AWS_CATALOG_LOADED = 'AWS_CATALOG_LOADED';
export const AWS_CATALOG_FAILED = 'AWS_CATALOG_FAILED';

const errorText = (err) => (err.response && err.response.data && err.response.data.message) || err.message;

export const fetchAwsRegions = (credentialId) => async (dispatch) => {
	if (!credentialId) return;
	dispatch({ type: AWS_REGIONS_LOADING, payload: { credentialId } });
	try {
		const response = await axios.get(API_BASE_URL + '/api/aws/regions', { params: { credentialId } });
		dispatch({ type: AWS_REGIONS_LOADED, payload: { credentialId, regions: response.data.regions || [] } });
	} catch (err) {
		dispatch({ type: AWS_REGIONS_FAILED, payload: { credentialId, error: errorText(err) } });
	}
};

export const fetchAwsCatalog = (credentialId, region) => async (dispatch) => {
	if (!credentialId || !region) return;
	const requestKey = credentialId + '|' + region;
	dispatch({ type: AWS_CATALOG_LOADING, payload: { requestKey, credentialId, region } });
	try {
		const response = await axios.get(API_BASE_URL + '/api/aws/catalog', { params: { credentialId, region } });
		dispatch({ type: AWS_CATALOG_LOADED, payload: { requestKey, data: response.data } });
	} catch (err) {
		dispatch({ type: AWS_CATALOG_FAILED, payload: { requestKey, error: errorText(err) } });
	}
};

// * ////////////// AZURE LIVE CATALOG ////////////// * //
// The Azure cluster form is credential-first and reads everything live from
// Azure: regions for the credential, then VM sizes / per-family quota /
// images / prices for the region. Nothing is cached, on purpose, and every
// request carries a requestKey so a slow response for a selection the user
// has already moved away from is dropped instead of overwriting the current
// one — the same contract as the AWS catalog above.

export const AZURE_REGIONS_LOADING = 'AZURE_REGIONS_LOADING';
export const AZURE_REGIONS_LOADED = 'AZURE_REGIONS_LOADED';
export const AZURE_REGIONS_FAILED = 'AZURE_REGIONS_FAILED';
export const AZURE_CATALOG_LOADING = 'AZURE_CATALOG_LOADING';
export const AZURE_CATALOG_LOADED = 'AZURE_CATALOG_LOADED';
export const AZURE_CATALOG_FAILED = 'AZURE_CATALOG_FAILED';
export const AZURE_TERMS_LOADING = 'AZURE_TERMS_LOADING';
export const AZURE_TERMS_DONE = 'AZURE_TERMS_DONE';
export const AZURE_TERMS_CLEAR = 'AZURE_TERMS_CLEAR';

export const fetchAzureRegions = (credentialId) => async (dispatch) => {
	if (!credentialId) return;
	dispatch({ type: AZURE_REGIONS_LOADING, payload: { credentialId } });
	try {
		const response = await axios.get(API_BASE_URL + '/api/azure/regions', { params: { credentialId } });
		dispatch({ type: AZURE_REGIONS_LOADED, payload: { credentialId, regions: response.data.regions || [] } });
	} catch (err) {
		dispatch({ type: AZURE_REGIONS_FAILED, payload: { credentialId, error: errorText(err) } });
	}
};

// os 'windows' prices the sizes at Azure's Windows rate (license included).
export const fetchAzureCatalog = (credentialId, region, os) => async (dispatch) => {
	if (!credentialId || !region) return;
	const requestKey = credentialId + '|' + region + (os === 'windows' ? '|windows' : '');
	dispatch({ type: AZURE_CATALOG_LOADING, payload: { requestKey, credentialId, region } });
	try {
		const params = os === 'windows' ? { credentialId, region, os } : { credentialId, region };
		const response = await axios.get(API_BASE_URL + '/api/azure/catalog', { params });
		dispatch({ type: AZURE_CATALOG_LOADED, payload: { requestKey, data: response.data } });
	} catch (err) {
		dispatch({ type: AZURE_CATALOG_FAILED, payload: { requestKey, error: errorText(err) } });
	}
};

/**
 * Has the subscription accepted a Marketplace plan's terms? Keyed by the exact
 * plan so answers can never race. `accepted: null` means the question could
 * not be asked — the form warns, it does not block.
 */
export const fetchAzureTerms = (credentialId, { publisher, offer, plan }) => async (dispatch) => {
	if (!credentialId || !publisher || !offer || !plan) return;
	const key = [credentialId, publisher, offer, plan].join('|');
	dispatch({ type: AZURE_TERMS_LOADING, payload: { key } });
	try {
		const response = await axios.post(API_BASE_URL + '/api/azure/marketplace-terms', {
			credentialId, publisher, offer, plan
		});
		dispatch({ type: AZURE_TERMS_DONE, payload: { key, terms: response.data } });
	} catch (err) {
		dispatch({ type: AZURE_TERMS_DONE, payload: { key, terms: { status: 'error', accepted: null, message: errorText(err) } } });
	}
};

export const clearAzureTerms = () => ({ type: AZURE_TERMS_CLEAR });

export const deleteAzureImage = ({ credentialId, region, imageId, confirmName, deleteStackId }) => async () => {
	try {
		const response = await axios.post(API_BASE_URL + '/api/azure/images/delete', {
			credentialId, region, imageId, confirmName, deleteStackId: deleteStackId || undefined
		});
		return response.data;
	} catch (err) {
		throw new Error(errorText(err));
	}
};

export const AWS_LAUNCH_CHECK_LOADING = 'AWS_LAUNCH_CHECK_LOADING';
export const AWS_LAUNCH_CHECK_DONE = 'AWS_LAUNCH_CHECK_DONE';

/**
 * AWS's own verdict on one (image, instance type, zone) via run-instances
 * --dry-run. Keyed by the exact combination so answers can never race.
 */
export const checkAwsLaunch = ({ credentialId, region, imageId, instanceType, zoneName }) => async (dispatch) => {
	const key = `${credentialId}|${region}|${imageId}|${instanceType}|${zoneName || ''}`;
	dispatch({ type: AWS_LAUNCH_CHECK_LOADING, payload: { key } });
	try {
		const response = await axios.post(API_BASE_URL + '/api/aws/validate-launch', { credentialId, region, imageId, instanceType, zoneName });
		dispatch({ type: AWS_LAUNCH_CHECK_DONE, payload: { key, result: response.data || { ok: true, skipped: 'empty' } } });
	} catch (err) {
		// Our own failure must never block the form.
		dispatch({ type: AWS_LAUNCH_CHECK_DONE, payload: { key, result: { ok: true, skipped: 'network: ' + errorText(err) } } });
	}
};

/**
 * Delete a Heidi image (AMI + snapshots) from the account behind the
 * credential, optionally with the Stack record that produced it. Resolves
 * with the API's result; rejects with a message on failure.
 */
export const deleteAwsImage = ({ credentialId, region, imageId, confirmName, deleteStackId }) => async () => {
	try {
		const response = await axios.post(API_BASE_URL + '/api/aws/images/delete', { credentialId, region, imageId, confirmName, deleteStackId: deleteStackId || undefined });
		return response.data;
	} catch (err) {
		throw new Error(errorText(err));
	}
};

export const AWS_SOFTWARE_PRICING_LOADING = 'AWS_SOFTWARE_PRICING_LOADING';
export const AWS_SOFTWARE_PRICING_DONE = 'AWS_SOFTWARE_PRICING_DONE';

/**
 * Marketplace software fee for product codes (the marketplace-AMI path; the
 * catalog carries pricing for product-coded images of its own). Keyed by the
 * exact request so answers cannot race.
 */
export const AWS_LAUNCH_CHECKS_CLEAR = 'AWS_LAUNCH_CHECKS_CLEAR';
/** Forget cached dry-run verdicts (e.g. after the account subscribed to a product). */
export const clearAwsLaunchChecks = () => ({ type: AWS_LAUNCH_CHECKS_CLEAR });

export const fetchAwsSoftwarePricing = ({ credentialId, region, productCodes }) => async (dispatch) => {
	const codes = [...new Set((productCodes || []).filter(Boolean))].sort();
	if (!credentialId || !region || codes.length === 0) return;
	const key = `${credentialId}|${region}|${codes.join(',')}`;
	dispatch({ type: AWS_SOFTWARE_PRICING_LOADING, payload: { key } });
	try {
		const response = await axios.get(API_BASE_URL + '/api/aws/software-pricing', { params: { credentialId, region, productCodes: codes.join(',') } });
		dispatch({ type: AWS_SOFTWARE_PRICING_DONE, payload: { key, result: response.data || { status: 'error', byProductCode: {} } } });
	} catch (err) {
		dispatch({ type: AWS_SOFTWARE_PRICING_DONE, payload: { key, result: { status: 'error', message: errorText(err), byProductCode: {} } } });
	}
};

// * ////////////// MARKETPLACE AMI RESOLUTION ////////////// * //
// Used by AWS marketplace variants that declare a `marketplace_product_code`
// instead of a static region→AMI map. Backed by POST /api/marketplace/resolve-ami.

export const SET_MARKETPLACE_AMI = 'SET_MARKETPLACE_AMI';
export const setMarketplaceAmi = (data) => ({
	type: SET_MARKETPLACE_AMI,
	payload: data
});

export const SET_MARKETPLACE_AMI_LOADING = 'SET_MARKETPLACE_AMI_LOADING';
export const setMarketplaceAmiLoading = (loading) => ({
	type: SET_MARKETPLACE_AMI_LOADING,
	payload: loading
});

export const SET_MARKETPLACE_AMI_ERROR = 'SET_MARKETPLACE_AMI_ERROR';
export const setMarketplaceAmiError = (error) => ({
	type: SET_MARKETPLACE_AMI_ERROR,
	payload: error
});

export const CLEAR_MARKETPLACE_AMI = 'CLEAR_MARKETPLACE_AMI';
export const clearMarketplaceAmi = () => ({
	type: CLEAR_MARKETPLACE_AMI
});

/**
 * Resolve the latest AMI for a marketplace product variant in a given region.
 * Backend calls `ec2 describe-images --filters product-code=...` and returns
 * the most recently created matching image.
 *
 * @param {Object} params - { credentialId, region, productCode, architecture, nameMustContain }
 */
export const resolveMarketplaceAmi = (params) => async (dispatch) => {
	var credentialId = params.credentialId;
	var region = params.region;
	var productCode = params.productCode;
	var architecture = params.architecture;
	var nameMustContain = params.nameMustContain;

	if (!credentialId || !region || !productCode || !architecture) {
		// Not enough info yet to resolve — clear any prior result so the form
		// doesn't keep showing a stale AMI for a different variant/region.
		dispatch(setMarketplaceAmi({ imageId: null, name: null, creationDate: null, region: region || null }));
		return;
	}

	dispatch(setMarketplaceAmiLoading(true));
	dispatch(setMarketplaceAmiError(null));

	try {
		var response = await axios.post(API_BASE_URL + '/api/marketplace/resolve-ami', {
			credentialId: credentialId,
			provider: 'aws',
			region: region,
			productCode: productCode,
			architecture: architecture,
			nameMustContain: nameMustContain || undefined
		});

		dispatch(setMarketplaceAmi({
			imageId: response.data.imageId || null,
			name: response.data.name || null,
			creationDate: response.data.creationDate || null,
			region: response.data.region || region,
			// Image attributes so the form can grey out shapes the AMI cannot boot on.
			arch: response.data.arch || null,
			virt: response.data.virt || null,
			bootMode: response.data.bootMode || null,
			ena: response.data.ena,
			rootDeviceType: response.data.rootDeviceType || null,
			productCodes: response.data.productCodes || []
		}));

		return response.data;
	} catch (err) {
		var errorMessage = err.response && err.response.data && err.response.data.message
			? err.response.data.message
			: err.message;
		console.error('Failed to resolve marketplace AMI:', errorMessage);
		dispatch(setMarketplaceAmiError(errorMessage));
		dispatch(setMarketplaceAmi({ imageId: null, name: null, creationDate: null, region: region }));
		return null;
	} finally {
		dispatch(setMarketplaceAmiLoading(false));
	}
};

/**
 * Resolve the NEWEST published version of an Azure Marketplace image
 * (publisher/offer/sku). The Azure analog of resolveMarketplaceAmi: it hits
 * POST /api/marketplace/resolve-azure-image, which asks Azure for the image
 * versions published for that publisher/offer/sku and returns the latest
 * non-deprecated one. Returns `{ version, urn, ... }` (or null) so the caller
 * can pin the resolved version onto the form, exactly like AWS pins the
 * resolved AMI id. Avoids a hard-pinned catalog version going stale.
 *
 * `location` matters: marketplace images are published per region, so the
 * version list is asked for the region being deployed into.
 *
 * @param {Object} params - { credentialId, publisher, offer, sku, location }
 */
export const resolveMarketplaceAzureImage = (params) => async () => {
	var credentialId = params.credentialId;
	var publisher = params.publisher;
	var offer = params.offer;
	var sku = params.sku;
	var location = params.location;

	if (!credentialId || !publisher || !offer || !sku) {
		return null;
	}

	try {
		var response = await axios.post(API_BASE_URL + '/api/marketplace/resolve-azure-image', {
			credentialId: credentialId,
			publisher: publisher,
			offer: offer,
			sku: sku,
			location: location
		});
		return response.data; // { version, urn, publisher, offer, sku }
	} catch (err) {
		var errorMessage = err.response && err.response.data && err.response.data.message
			? err.response.data.message
			: err.message;
		console.error('Failed to resolve Azure marketplace image version:', errorMessage);
		return null;
	}
};

/**
 * Check zone availability for selected instance types
 * @param {Object} params - { credentialId, provider, region, instanceTypes }
 */
export const checkZoneAvailability = (params) => async (dispatch) => {
	var credentialId = params.credentialId;
	var provider = params.provider;
	var region = params.region;
	var instanceTypes = params.instanceTypes;
	
	if (!credentialId || !provider || !region || !instanceTypes || instanceTypes.length === 0) {
		return;
	}
	
	dispatch(setZoneAvailabilityLoading(true));
	dispatch(setZoneAvailabilityError(null));
	
	try {
		var response = await axios.post(API_BASE_URL + '/api/instance-availability/check-zones', {
			credentialId: credentialId,
			provider: provider,
			region: region,
			instanceTypes: instanceTypes
		});
		
		dispatch(setZoneAvailability({
			zones: response.data.zones || {},
			provider: provider,
			region: region,
			instanceTypes: instanceTypes,
			timestamp: Date.now(),
			unableToVerify: response.data.unableToVerify || false,
			error: response.data.error || null
		}));
		
		return response.data;
	} catch (err) {
		var errorMessage = err.response && err.response.data && err.response.data.message 
			? err.response.data.message 
			: err.message;
		console.error('Failed to check zone availability:', errorMessage);
		dispatch(setZoneAvailabilityError(errorMessage));
		// Don't throw - just log and continue
		return null;
	} finally {
		dispatch(setZoneAvailabilityLoading(false));
	}
};

// * ////////////// HEADERS ////////////// * //
const headers = {
	headers: {
		admin: true
	}
};
const repeatHeader = {
	headers: {
		repeatCall: true
	}
};

// * ////////////// NEW ////////////// * //

export const newCluster = () => dispatch => {
	const cluster = {
		credential_id: '',
		data: {
			marketplace_image_reference: {
				offer: null,
				sku: null,
				marketplace_image_version: null,
				publisher: null,
				requires_plan: false
			},
			rhel_activation_key: null,
			rhel_organization_id: null,
			ec2_role: false, // TODO aws
			LPG: undefined,
			vcn_cidr: undefined,
			local_cidr: undefined,
			image_resource_group_name: '',
			resource_group_id: null,
			manager: 'none',
			network: {
				eip_id: '',
				fip_address: '',
				firewall_id: '',
				network_id: '',
				region_id: '',
				security_group_id: '',
				subnet_id: '',
				vpc_id: '',
				zone_id: '',
				zone_name:'',
				availability_domain: '',
				vswitch_id: '',
				vcn_id: '',
				private_static_ip: null,
				enable_node_internet_access: true,
			},
			node: {
				group: [{ 
					count: 0, 
					instance_id: '', 
					ocpus: 1, 
					mem: 1, 
					group_node_prefix: '', 
					efa: false, 
					group_node_prefix_label: null, 
					image_type: IMAGE_TYPE.HEIDI_STACK,
					attachedVolumes: [], // Initialize with new architecture
					accelerator_type: null,
					accelerator_count: 0
				}],
				volume_size: '',
				disk_type: null,
				accelerator_type: null,
				accelerator_count: null
			},
			packages: [],
			provision: { script: '' },
			server: {
				disk_type: null,
				instance_id: '',
				isPrivate: false,
				openvpn: false,
				volume_size: '',
				ocpus: 1,
				mem: 1,
				image_type: IMAGE_TYPE.HEIDI_STACK,
				accelerator_type: null,
				accelerator_count: null

			},
			service_account: false, // TODO google
			share: 'nfs',
			storageConfigurations: [], // Initialize storage configurations array
			moab: {
				ip: '',
				hostname: ''
			},
			tpu: {
				enabled: false,
				accelerator_type: 'v2-8',
				runtime_version: 'tpu-vm-tf-2.13.0',
				count: 1,
				cidr_block: '',
				preemptible: false,
				spot: false,
				enable_external_ips: false,
				service_account_email: '',
				startup_script: '',
				zone: '',
				reservation_id: ''
			}
		},
		description: '',
		info: {
			bursting: {
				burstOnDeploy: false,
				mode: 'min'
			},
			'os-type': 'ubuntu-22.04',
			prefix: '',
			node_prefix: '',
			vncTokenAuthentication: undefined,
			vncRemoteClient: undefined
		},
		name: '',
		displayName: '',
		provider: '',
		tags: [],
	};
	dispatch(setCluster({ cluster }));
};

export const newMarketCluster = (marketData) => dispatch => {
	// If the marketplace entry has variants[], merge the first variant's config
	// on top of the product-level config so legacy callers still get a usable
	// config shape. (The real variant selection is driven by the form via
	// useMarketplace; this is only a defensive default for this legacy path.)
	const config = { ...(marketData?.config || {}), ...(marketData?.variants?.[0]?.config || {}) };
	const defaultNodeCount = config.node_count || '1';
	const defaultComputeNodeSize = config.computeNodeSize?.[0] || '';
	const defaultNodePrefix = config.node_prefix || 'node';
	// Always use Heidi Stack image type — user selects their own image within the form
	const defaultImageType = IMAGE_TYPE.HEIDI_STACK;
	
	const cluster = {
		credential_id: '',
		data: {
			marketplace_image_reference: {
				offer: null,
				sku: null,
				marketplace_image_version: null,
				publisher: null,
				requires_plan: false
			},
			ec2_role: false, // TODO aws
			LPG: undefined,
			vcn_cidr: undefined,
			local_cidr: undefined,
			image_resource_group_name: '',
			resource_group_id: null,
			manager: 'none',
			network: {
				eip_id: '',
				fip_address: '',
				firewall_id: '',
				network_id: '',
				region_id: '',
				security_group_id: '',
				subnet_id: '',
				vpc_id: '',
				zone_id: '',
				zone_name:'',
				availability_domain: '',
				vswitch_id: '',
				vcn_id: '',
				private_static_ip: null
			},
			node: {
				group: [{ 
					count: defaultNodeCount, 
					instance_id: defaultComputeNodeSize, 
					ocpus: 1, 
					mem: 1, 
					group_node_prefix: defaultNodePrefix, 
					efa: true, 
					group_node_prefix_label: null, 
					image_type: defaultImageType,
					attachedVolumes: [], // Initialize with new architecture
					accelerator_type: null,
					accelerator_count: 0
				}],
				volume_size: config.min_volume || 100,
				idle_purge_s: 600,
				disk_type: null
			},
			packages: [],
			provision: { script: '' },
			server: {
				disk_type: null,
				instance_id: config.instance_type?.[0] || '',
				isPrivate: false,
				openvpn: false,
				image_name: config.server_prefix || 'server',
				image_type: defaultImageType,
				volume_size: config.min_volume || 100,
				ocpus: 1,
				mem: 1,
			},
			service_account: false, // TODO google
			share: 'nfs',
			storageConfigurations: [], // Initialize storage configurations array
			moab: {
				ip: '',
				hostname: ''
			},
			tpu: {
				enabled: false,
				accelerator_type: 'v2-8',
				runtime_version: 'tpu-vm-tf-2.12',
				count: 1,
				cidr_block: '',
				preemptible: false,
				spot: false,
				enable_external_ips: false,
				service_account_email: '',
				startup_script: '',
				zone: '',
				reservation_id: ''
			}
		},
		description: '',
		info: {
			bursting: {
				burstOnDeploy: false,
				mode: 'min'
			},
			'os-type': config.os_types || 'ubuntu-22.04',
			vnTokenAuthentication: undefined,
			// Unified image mode: from stack buildMode or marketplace config image_mode
			imageMode: config.image_mode === 'unified' || marketData?.buildMode === 'unified' 
				? 'unified' 
				: 'multi-image',
			// Pass the unified image ID from stack if available
			unifiedImageId: marketData?.unifiedImageId || null,
		},
		// Pre-populate applications from marketplace config
		applications: (config.applications || []).map(function(app, index) {
			return {
				id: app.id || (marketData?.id || 'app') + '-' + index,
				name: app.name || '',
				url: app.url || '',
				icon: app.icon || 'apps',
				description: app.description || '',
				category: app.category || 'general',
				launchType: app.launchType || 'url',
				instructions: app.instructions || '',
				enabled: app.enabled !== false,
				actionType: app.actionType || 'access-tab',
				actionButtonLabel: app.actionButtonLabel || ''
			};
		}),
		name: '',
		displayName: '',
		provider: '',
		tags: [],
	};
	dispatch(setMarketCluster({ cluster }));
};

// * ////////////// REPEATS ////////////// * //

export const getClusterRepeat = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/${params.id}`, repeatHeader);
	return request
		.then(res => {
			const newCluster = res.data;

			// Get previous cluster state from store before updating
			const previousCluster = store.getState()?.clusters?.cluster?.cluster;

			// Update cluster in store
			dispatch(setCluster(newCluster));

			// Check for state changes and trigger AI analysis if needed
			if (previousCluster && newCluster) {
				dispatch(handleClusterStateChange(previousCluster, newCluster));
			}

			return res;
		})
		.catch(err => {
			const errorData = (err.response && err.response.data) || err.data || {};
			const status = err.response && err.response.status;
			const message = errorData.message || (status === 404 ? 'Cluster not found' : 'Failed to load cluster');
			dispatch(setClusterError({ ...errorData, message, status, type: 'modal' }));
		});
};
export const getMarketClusterRepeat = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/${params.id}`, repeatHeader);
	return request
		.then(res => dispatch(setMarketCluster(res.data)))
		.catch(err => dispatch(setClusterError({ ...err.data, type: 'modal' })));
};

export const getLogsRepeat = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/logs/${params.id}/${params.type}`, repeatHeader);
	return request
		.then(res => dispatch(setLogs(res.data.logs, params.id)))
		.catch(err => dispatch(setClusterError({ ...err.data, type: 'modal' })));
};

export const getClustersRepeat = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/`, repeatHeader);
	return request
		.then(res => {
			const newClusters = res.data;
			
			// Get previous clusters list from store
			const previousClusters = store.getState()?.clusters?.cluster?.list || [];
			
			// Update clusters list in store
			dispatch(setClustersList(newClusters));
			
			// Check each cluster for state changes
			newClusters.forEach(newCluster => {
				const previousCluster = previousClusters.find(c => c.id === newCluster.id);
				if (previousCluster) {
					dispatch(handleClusterStateChange(previousCluster, newCluster));
				}
			});
			
			return res;
		})
		.catch(err => dispatch(setClusterError({ ...err.data, type: 'modal' })));
};

export const getParticipantClustersRepeat = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/participant`, repeatHeader);
	return request
		.then(res => dispatch(setClustersList(res.data)))
		.catch(err => dispatch(setClusterError({ ...err.data, type: 'modal' })));
};

// * ////////////// CLUSTER HEALTH ////////////// * //

export const fetchClusterHealth = (clusterId) => async () => {
	try {
		const endpoint = `${API_BASE_URL}/api/clusters/${clusterId}/health`;
		const response = await axios.get(endpoint);
		return response.data;
	} catch (error) {
		// Handle 404 errors gracefully - cluster may not have health data yet
		if (error.response && error.response.status === 404) {
			console.warn(`No health data available for cluster ${clusterId}`);
			return {
				status: 'unknown',
				message: 'No health data available',
				clusterId: clusterId,
				lastChecked: null,
				consecutiveFailures: 0,
				healthData: null,
				responseTime: null
			};
		}
		console.error('Error fetching cluster health:', error);
		return null;
	}
};

export const forceClusterHealthCheck = (clusterId) => async () => {
	try {
		const endpoint = `${API_BASE_URL}/api/clusters/${clusterId}/health/check`;
		const response = await axios.post(endpoint, {});
		return response.data;
	} catch (error) {
		console.error('Error forcing cluster health check:', error);
		if (error.response) {
			throw new Error(`Health check failed: ${error.response.status} - ${error.response.data?.message || error.message}`);
		}
		throw error;
	}
};

export const updateClusterSystem = (clusterId) => async () => {
	try {
		const endpoint = `${API_BASE_URL}/api/clusters/update-system/${clusterId}`;
		const response = await axios.post(endpoint);
		return response.data;
	} catch (error) {
		console.error('Error updating cluster system:', error);
		if (error.response) {
			throw new Error(`System update failed: ${error.response.status} - ${error.response.data?.message || error.message}`);
		}
		throw error;
	}
};

export const getAvailableClusters = () => async () => {
	try {
		const endpoint = `${API_BASE_URL}/api/clusters`;
		const response = await axios.get(endpoint);
		// Filter clusters with state 'available'
		const available = response.data.filter(cluster => 
			cluster.info && cluster.info.state === 'available'
		);
		return available;
	} catch (error) {
		console.error('Error fetching available clusters:', error);
		if (error.response) {
			throw new Error(`Failed to fetch clusters: ${error.response.status} - ${error.response.data?.message || error.message}`);
		}
		throw error;
	}
};

// Get cluster details for developer tools
export const getClusterDetails = (clusterId) => async dispatch => {
	try {
		const request = axios.get(`${API_BASE_URL}/api/clusters/${clusterId}`);
		const response = await request;
		return response.data;
	} catch (error) {
		console.error('Error fetching cluster details:', error);
		dispatch(setClusterError({ ...error.response?.data || error, type: 'modal' }));
		throw error;
	}
};

// Execute cluster action via developer API
export const executeClusterAction = (clusterId, action, config, createTestCluster = true) => async dispatch => {
	try {
		const request = axios.post(`${API_BASE_URL}/api/dev/cluster-action`, {
			clusterId,
			action,
			config,
			createTestCluster
		}, headers);
		const response = await request;
		return response.data;
	} catch (error) {
		console.error('Error executing cluster action:', error);
		dispatch(setClusterError({ ...error.response?.data || error, type: 'modal' }));
		throw error;
	}
};

// Get job status for cluster actions
export const getJobStatus = (jobId) => async dispatch => {
	try {
		const request = axios.get(`${API_BASE_URL}/api/dev/job-status/${jobId}`);
		const response = await request;
		return response.data;
	} catch (error) {
		console.error('Error fetching job status:', error);
		// Don't dispatch error for job status checks as they may fail normally
		throw error;
	}
};

export const fetchAllClusterHealth = (clusters) => async dispatch => {
	if (!clusters || clusters.length === 0) return;
	
	dispatch(setClusterHealthLoading(true));
	
	try {
		const healthPromises = clusters.map(async (cluster) => {
			// Call the function directly instead of dispatching
			const healthAction = fetchClusterHealth(cluster.id);
			const health = await healthAction();
			return { clusterId: cluster.id, health };
		});

		const healthResults = await Promise.all(healthPromises);
		const healthMap = {};
		healthResults.forEach(({ clusterId, health }) => {
			if (health) {
				healthMap[clusterId] = health;
			}
		});
		
		dispatch(setClusterHealthData(healthMap));
	} catch (error) {
		console.error('Error fetching all cluster health:', error);
	} finally {
		dispatch(setClusterHealthLoading(false));
	}
};

// * ////////////// CLUSTER METRICS ////////////// * //

// What a rejected request actually hands a call site here.
//
// jwtService installs a global axios response interceptor that ends in
// `reject(response)` - it rejects with the RESPONSE, not with the axios
// error. So `error.response` is undefined and the status sits directly on
// `error`. Every `error.response && error.response.status` check in this
// file is therefore dead in the running app: a 404 that should be read as
// "nothing collected yet" falls through to the generic failure branch, and
// a customer looking at a brand new cluster gets a red "Failed to fetch
// cluster metrics" box instead of an empty panel.
//
// Read both shapes rather than change the interceptor, which every other
// call site in the app is written against.
const errorResponse = error => (error && error.response) || error || {};
export const fetchClusterMetrics = (clusterId) => async dispatch => {
	dispatch(setClusterMetricsLoading(true));
	dispatch(setClusterMetricsError(null));

	try {
		const response = await axios.get(`${API_BASE_URL}/api/cluster-metrics/${clusterId}/latest`);
		if (response.data.status === 'success') {
			dispatch(setClusterMetrics(response.data.data));
		}
		return response.data;
	} catch (error) {
		const response = errorResponse(error);
		// 404 = no metrics collected yet (normal for new/idle clusters). Not an error:
		// stay quiet, clear any error, and resolve (avoids console spam + the
		// "Uncaught (in promise)"). Never log the raw error object - it carries the
		// request config incl. the Authorization header.
		if (response.status === 404) {
			dispatch(setClusterMetricsError(null));
			return null;
		}
		const errorMessage = (response.data && response.data.message) || 'Failed to fetch cluster metrics';
		console.error('Error fetching cluster metrics:', errorMessage);
		dispatch(setClusterMetricsError(errorMessage));
		return null;
	} finally {
		dispatch(setClusterMetricsLoading(false));
	}
};

export const fetchClusterMetricsHistory = (clusterId, hours = 24, selectedNode = 'all') => async dispatch => {
	dispatch(setClusterMetricsLoading(true));
	dispatch(setClusterMetricsError(null));

	try {
		// Always use the /history endpoint to get full metrics data with all nodes
		// The component will filter by selectedNode on the frontend
		const response = await axios.get(`${API_BASE_URL}/api/cluster-metrics/${clusterId}/history?hours=${hours}`);
		if (response.data.status === 'success') {
			dispatch(setClusterMetricsHistory(response.data.data));
		}
		return response.data;
	} catch (error) {
		const response = errorResponse(error);
		if (response.status === 404) {
			dispatch(setClusterMetricsError(null));
			return null;
		}
		const errorMessage = (response.data && response.data.message) || 'Failed to fetch cluster metrics history';
		console.error('Error fetching cluster metrics history:', errorMessage);
		dispatch(setClusterMetricsError(errorMessage));
		return null;
	} finally {
		dispatch(setClusterMetricsLoading(false));
	}
};

export const forceClusterMetricsCollection = (clusterId) => async dispatch => {
	dispatch(setClusterMetricsLoading(true));
	dispatch(setClusterMetricsError(null));

	try {
		const response = await axios.post(`${API_BASE_URL}/api/cluster-metrics/${clusterId}/collect`);
		if (response.data.status === 'success') {
			// Wait a moment then refresh metrics data
			setTimeout(() => {
				dispatch(fetchClusterMetrics(clusterId));
			}, 2000);
		}
		return response.data;
	} catch (error) {
		console.error('Error forcing metrics collection:', error.message);
		const errorMessage = errorResponse(error).data?.message || 'Failed to force metrics collection';
		dispatch(setClusterMetricsError(errorMessage));
		throw error;
	} finally {
		dispatch(setClusterMetricsLoading(false));
	}
};

export const fetchClusterAnalytics = (clusterId, hours = 24) => async dispatch => {
	try {
		const response = await axios.get(`${API_BASE_URL}/api/cluster-metrics/${clusterId}/analytics?hours=${hours}`);
		return response.data;
	} catch (error) {
		console.error('Error fetching cluster analytics:', error.message);
		throw error;
	}
};

// * ////////////// CLUSTER SPARKLINES ////////////// * //

export const SET_CLUSTER_SPARKLINES = 'SET_CLUSTER_SPARKLINES';
export const setClusterSparklines = data => ({
	type: SET_CLUSTER_SPARKLINES,
	payload: data
});

export const fetchClusterSparklines = (clusterIds) => async dispatch => {
	if (!clusterIds || clusterIds.length === 0) return;
	try {
		const response = await axios.post(`${API_BASE_URL}/api/cluster-metrics/sparklines`, {
			clusterIds,
			hours: 1,
			points: 20
		});
		if (response.data.status === 'success') {
			dispatch(setClusterSparklines(response.data.data));
		}
	} catch (error) {
		console.error('Error fetching cluster sparklines:', error.message);
	}
};

// * ////////////// GET ////////////// * //

export const provider_os_types = (provider) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/osTypes/${provider}`);
	return request
		.then(response => dispatch(setProviderOsTypes(response.data)))
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getCluster = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/${params.id}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setCluster(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			const errorData = (err.response && err.response.data) || err.data || {};
			const status = err.response && err.response.status;
			const message = errorData.message || (status === 404 ? 'Cluster not found' : 'Failed to load cluster');
			dispatch(setClusterError({ ...errorData, message, status, type: 'modal' }));
		});
};

export const getMarketCluster = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/${params.id}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setMarketCluster(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getClusters = () => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClustersList(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getParticipantClusters = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/participant`);
	return request
		.then(response => {
			dispatch(setClustersList(response.data));
		})
		.catch(err => {
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getPreconfiguredDevices = () => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/preconfigured-devices`);
	return request
		.then(response => {
			dispatch(setPreconfiguredDevices(response.data.device_families || []));
			return response.data.device_families || [];
		})
		.catch(err => {
			console.error('Error fetching preconfigured devices:', err);
			dispatch(setPreconfiguredDevices([]));
			return [];
		});
};

export const getNode = ({ node, cluster }) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/node/${cluster}/${node}`, headers);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setNode(response.data));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getLogs = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/logs/${params.id}/${params.type}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setLogs(response.data.logs, params.id));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};
export const getLogURLs = params => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.get(`${API_BASE_URL}/api/clusters/logs/${params.id}/${params.type}`);
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			const urlPattern = /(https?:\/\/[^\s]+)/g;
			const extractedLinks = response.data.logs.match(urlPattern);
			dispatch(setLogURLs(extractedLinks));
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const getClusterActivities = params => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/activities/${params.id}`);
	return request
		.then(response => dispatch(setClusterActivities(response.data)))
		.catch(err => dispatch(setClusterError({ ...err.data, type: 'modal' })));
};

export const getGpuMetrics = (clusterId, timeRange = '24h') => dispatch => {
	dispatch(setGpuMetricsLoading(true));
	dispatch(setGpuMetricsError(null));
	
	const request = axios.get(`${API_BASE_URL}/api/clusters/${clusterId}/gpu-metrics`, {
		params: { timeRange }
	});
	
	return request
		.then(response => {
			dispatch(setGpuMetricsLoading(false));
			dispatch(setGpuMetrics(response.data));
		})
		.catch(err => {
			dispatch(setGpuMetricsLoading(false));
			dispatch(setGpuMetricsError(err.response?.data?.message || 'Failed to load GPU metrics'));
		});
};

export const getGpuMetricsSummary = (clusterId) => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/${clusterId}/gpu-metrics/summary`);
	
	return request
		.then(response => {
			dispatch(setGpuMetricsSummary(response.data));
		})
		.catch(err => {
			console.error('Failed to load GPU metrics summary:', err);
		});
};

export const downloadSSHKey = cluster => () => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/downloadSSHKey/${cluster.id}`, {
		responseType: 'blob'
	});
	return request.then(response => saveAs(response.data, `${cluster.name}-SSH-Key`));
};

export const downloadOpenvpn = cluster => () => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/openvpn/${cluster.id}`, {
		responseType: 'blob'
	});
	return request.then(response => saveAs(response.data, `${cluster.name}-OpenVPN`));
};

export const createVNCSession = clusterId => async () => {
	const response = await axios.get(`${API_BASE_URL}/api/clusters/createVNCSession/${clusterId}`);
	return response;
};

export const createVNCSessionWithCommand = (clusterId, clusterCommand) => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/clusters/createVNCSession`, { 
		clusterId, 
		clusterCommand 
	});
	return response;
};

export const cleanupVNCTokens = (clusterId = null) => async dispatch => {
	try {
		const response = await axios.post(`${API_BASE_URL}/api/clusters/cleanupVNCTokens`, { clusterId }, headers);
		return response.data;
	} catch (error) {
		console.error('VNC token cleanup failed:', error);
		throw error;
	}
};

export const createDCVSession = clusterId => async () => {
	const response = await axios.get(`${API_BASE_URL}/api/clusters/createDCVSession/${clusterId}`);
	return response;
};

// Feature: windows-desktop-vms. The backend mints a one-time proxy token and
// returns the relative /rdp/<token>/ URL to open - same shape as the DCV/
// Heidi Desktop pairs above, except there is only this one call: Guacamole
// (not Heidi) owns the actual remote-desktop session from here.
export const createWindowsDesktopSession = clusterId => async () => {
	try {
		const response = await axios.get(`${API_BASE_URL}/api/windows-desktop/clusters/${clusterId}/connect`);
		return response;
	} catch (error) {
		// Surface the server's own message (e.g. the 2-user session-cap
		// rejection) instead of axios's generic "Request failed with status
		// code 409" - launchRdpViewer's catch block shows error.message
		// straight in a snackbar.
		throw new Error((error.response && error.response.data && error.response.data.message) || error.message);
	}
};

// Feature: windows-desktop-vms. "Windows Desktop" is an Operating System
// choice inside the normal Azure cluster form (azure/form.js) - this posts
// to its own endpoint instead of saveCluster because the backend path is
// completely different (no Heidi image catalog, no compute node groups).
export const createWindowsDesktopCluster = payload => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/windows-desktop/clusters`, payload);
	return response;
};

// Feature: windows-desktop-vms on MaaS. The Ready machines and windows/* boot
// resources the chosen MaaS credential can deploy, read straight from MaaS
// (GET /api/windows-desktop/maas/options) - the MaaS form's Windows Desktop
// choice lists these instead of the ACM shapes and layers Linux clusters use.
export const getMaasWindowsOptions = credentialId => async () => {
	const response = await axios.get(`${API_BASE_URL}/api/windows-desktop/maas/options`, { params: { credentialId } });
	return response.data;
};

// Feature: windows-desktop-vms. Only works while the cluster is still staged
// (state 'down', never deployed) - the backend route 409s otherwise. Reuses
// the create form's own validation/payload shape, just a different verb.
export const updateWindowsDesktopCluster = (id, payload) => async () => {
	const response = await axios.put(`${API_BASE_URL}/api/windows-desktop/clusters/${id}`, payload);
	return response;
};

// Feature: windows-desktop-vms. Saving the create form only persists the
// cluster record now (matching every other provider) - this is the separate
// "Deploy" action that actually runs terraform. Hits the dedicated route
// (commands/cluster/azure-windows/deploy.js) rather than the generic
// deployCluster's /api/clusters/:id/deploy, which assumes an SSH/HNA Linux
// head node.
export const deployWindowsDesktopCluster = id => dispatch => {
	dispatch(setClusterOptimisticState(id, 'deploying'));

	const request = axios.post(`${API_BASE_URL}/api/windows-desktop/clusters/${id}/deploy`, {}, headers);

	return request
		.then(() => {
		})
		.catch(err => {
			dispatch(setClusterOptimisticState(id, 'down'));
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			const message = (err.data && err.data.message) || (err.response && err.response.data && err.response.data.message) || 'Deploy failed';
			dispatch(showMessage({ message, variant: 'error', autoHideDuration: 15000 }));
		});
};

// Feature: windows-desktop-vms. The generic destroyCluster() posts to
// /api/clusters/:id/destroy, which runs the SSH/HNA-dependent generic
// destroy pipeline - against a Windows cluster (no SSH) it fails fast and
// marks the cluster "failed" in Mongo WITHOUT running terraform destroy,
// silently orphaning the real Azure VM. This hits the dedicated route
// (commands/cluster/azure-windows/destroy.js) instead, which actually
// tears down the Terraform-managed resources.
// Destroy then deploy again with the same configuration, on the server; the
// generic recycleCluster path is SSH/HNA-based and cannot reach Windows.
export const recycleWindowsDesktopCluster = id => dispatch => {
	dispatch(showMessage({ message: 'Cluster Recycle Initiated' }));
	dispatch(setClusterOptimisticState(id, 'destroying'));

	return axios.post(`${API_BASE_URL}/api/windows-desktop/clusters/${id}/recycle`, {}, headers)
		.catch(err => {
			const message = (err.response && err.response.data && err.response.data.message) || 'Recycle failed';
			dispatch(showMessage({ message, variant: 'error', autoHideDuration: 15000 }));
		});
};

export const destroyWindowsDesktopCluster = id => dispatch => {
	dispatch(showMessage({ message: 'Cluster Destroy Initiated' }));
	dispatch(ActionsDialog.toggleLoading());
	dispatch(setClusterOptimisticState(id, 'destroying'));

	const request = axios.delete(`${API_BASE_URL}/api/windows-desktop/clusters/${id}`, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(setClusterOptimisticState(id, 'available'));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const downloadDCVConnectionFile = clusterId => async () => {
	const response = await axios.get(`${API_BASE_URL}/api/clusters/dcvConnectionFile/${clusterId}`, {
		responseType: 'blob'
	});
	return response;
};

export const terminateDCVSession = clusterId => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/clusters/terminateDCVSession`, { clusterId }, headers);
	return response;
};

// Heidi Desktop (Selkies WebRTC) — mirrors the DCV pair above. The backend
// endpoints are /api/clusters/launchDesktop/:cluster (GET) for create and
// /api/clusters/terminateDesktopSession (POST) for terminate.
export const createDesktopSession = clusterId => async () => {
	const response = await axios.get(`${API_BASE_URL}/api/clusters/launchDesktop/${clusterId}`);
	return response;
};

// Preflight: returns { activeClients: <int> } so the UI can show a
// "session already open elsewhere" modal before kicking the existing tab
// and triggering selkies's WebSocket-level takeover loop.
// Configured `skipForbiddenToast` because participant role legitimately
// 403s on the desktop endpoints; the consumer falls back to "no other
// session" when the call fails.
export const checkDesktopActive = clusterId => async () => {
	const response = await axios.get(
		`${API_BASE_URL}/api/clusters/checkDesktopActive/${clusterId}`,
		{ skipForbiddenToast: true }
	);
	return response;
};

export const terminateDesktopSession = clusterId => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/clusters/terminateDesktopSession`, { clusterId }, headers);
	return response;
};

// Windows Desktop (RDP via Guacamole) — mirrors the DCV/Desktop pair above.
// The backend does a real WinRM `logoff`, not just proxy-side bookkeeping.
export const terminateRdpSession = clusterId => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/clusters/terminateRdpSession`, { clusterId }, headers);
	return response;
};

export const cleanupDCVSessions = (clusterId = null) => async dispatch => {
	try {
		const response = await axios.post(`${API_BASE_URL}/api/clusters/cleanupDCVSessions`, { clusterId }, headers);
		return response.data;
	} catch (error) {
		console.error('DCV session cleanup failed:', error);
		throw error;
	}
};

export const checkUserExistence = (clusterId, username) => async dispatch => {
	try {
		const response = await axios.get(`${API_BASE_URL}/api/clusters/${clusterId}/check-user/${username}`);
		return response;
	} catch (error) {
		console.error('User existence check failed:', error);
		throw error;
	}
};

export const syncUserToCluster = (clusterId, username) => async dispatch => {
	try {
		const response = await axios.post(`${API_BASE_URL}/api/clusters/${clusterId}/sync-user`, { username });
		return response;
	} catch (error) {
		console.error('User sync to cluster failed:', error);
		throw error;
	}
};

export const participantCheckUserExistence = (clusterId, username) => async dispatch => {
	try {
		const response = await axios.get(`${API_BASE_URL}/api/clusters/participant/${clusterId}/check-user/${username}`);
		return response;
	} catch (error) {
		console.error('Participant user existence check failed:', error);
		throw error;
	}
};

export const participantSyncUserToCluster = (clusterId, username) => async dispatch => {
	try {
		const response = await axios.post(`${API_BASE_URL}/api/clusters/participant/${clusterId}/sync-user`, { username });
		return response;
	} catch (error) {
		console.error('Participant user sync to cluster failed:', error);
		throw error;
	}
};

// * ////////////// POST ////////////// * //

export const saveCluster = (cluster) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	
	// Extract ownerUsername from cluster object and send it separately
	const { ownerUsername, ...clusterData } = cluster;
	const requestBody = { cluster: clusterData };
	if (ownerUsername) {
		requestBody.ownerUsername = ownerUsername;
	}
	
	const request = axios.post(`${API_BASE_URL}/api/clusters/`, requestBody, headers);
	return request
		.then((res) => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
			dispatch(getClusters());
			return res
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			
			// Extract error details from response
			const errorData = err.response?.data || err.data || {};
			const errorMessage = errorData.message || 'There was an error saving the cluster.';
			const solution = errorData.solution || '';
			
			// Show snackbar with error message
			const fullMessage = solution ? `${errorMessage} ${solution}` : errorMessage;
			dispatch(showMessage({ 
				message: fullMessage, 
				variant: 'error',
				autoHideDuration: 10000 // Show for 10 seconds since it includes solution
			}));
			
			dispatch(setClusterError({ ...errorData, type: 'form' }));
			return err
		});
};

export const saveLocalCluster = cluster => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/local`, { cluster }, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'form' }));
		});
};

// * ////////////// PUT ////////////// * //

export const editCluster = (cluster, deletedPkgs, ownerUsername) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const requestBody = { cluster, deletedPkgs };
	if (ownerUsername) {
		requestBody.ownerUsername = ownerUsername;
	}
	const request = axios.put(`${API_BASE_URL}/api/clusters/${cluster.id}`, requestBody, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());

			// Extract error details from response
			const errorData = err.response?.data || err.data || {};
			const errorMessage = errorData.message || 'There was an error updating the cluster.';
			const solution = errorData.solution || '';

			// Show snackbar with error message
			const fullMessage = solution ? `${errorMessage} ${solution}` : errorMessage;
			dispatch(showMessage({
				message: fullMessage,
				variant: 'error',
				autoHideDuration: 10000
			}));

			dispatch(setClusterError({ ...errorData, type: 'form' }));
		});
};

export const editLocalCluster = cluster => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/local`, { cluster }, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(ActionsDialog.closeDialog());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'form' }));
		});
};

export const editCollaborators = data => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/collaborators`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const addLdapCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/ldap-collaborators/add`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const removeLdapCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/ldap-collaborators/remove`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const addOpenidcCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/openidc-collaborators/add`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
}

export const removeOpenidcCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/openidc-collaborators/remove`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};
export const addOrgCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/org-collaborators/add`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const removeOrgCollaborator = (data) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(`${API_BASE_URL}/api/clusters/${data.id}/org-collaborators/remove`, data, headers);
	return request
		.then(res => {
			dispatch(setSelected(res.data.cluster));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(getClusters());
			return res.data.cluster;
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

// Feature: two-orgs-one-tenancy - per-org desktop capacity split on a cluster
// shared across organizations. No global loading toggle: this backs a small
// panel inside the sharing dialog, not a full-page action.
export const getClusterCapacitySharing = (clusterId) => dispatch => {
	const request = axios.get(`${API_BASE_URL}/api/clusters/${clusterId}/capacity-sharing`, headers);
	return request
		.then(res => res.data)
		.catch(err => {
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			throw err;
		});
};

export const updateClusterCapacitySharing = (clusterId, data) => dispatch => {
	const request = axios.put(`${API_BASE_URL}/api/clusters/${clusterId}/capacity-sharing`, data, headers);
	return request
		.then(res => res.data)
		.catch(err => {
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			throw err;
		});
};

// * ////////////// DELETE ////////////// * //

export const deleteCluster = id => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.delete(`${API_BASE_URL}/api/clusters/${id}`, headers);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'Cluster Deleted' }));
			dispatch(getClusters());
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// ACTIONS ////////////// * //

export const deployCluster = (id, onlyplan = false, skipStorage = false) => dispatch => {
	// Optimistic update - show deploying state immediately
	if (!onlyplan) {
		dispatch(setClusterOptimisticState(id, 'deploying'));
	}

	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/deploy`, { onlyplan, skipStorage }, headers);

	return request
		.then(() => {
		})
		.catch(err => {
			// Revert optimistic state on failure
			if (!onlyplan) {
				dispatch(setClusterOptimisticState(id, 'down'));
			}
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			// The error modal only exists on the cluster detail view; from the
			// table a refused deploy (e.g. the AWS preflight) must still be seen.
			const message = (err.data && err.data.message) || (err.response && err.response.data && err.response.data.message) || 'Deploy failed';
			dispatch(showMessage({ message, variant: 'error', autoHideDuration: 15000 }));
		});
};

export const stopCluster = id => async dispatch => {
	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/stop`, {}, headers);
	return request
		.catch(err => {
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			throw err;
		});
};


export const startCluster = id => dispatch => {
	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/start`, {}, headers);
	return request
		.then(() => {
		})
		.catch(err => {
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const destroyCluster = id => dispatch => {
	dispatch(showMessage({ message: 'Cluster Destroy Initiated' }));
	dispatch(ActionsDialog.toggleLoading());
	// Optimistic update - show destroying state immediately
	dispatch(setClusterOptimisticState(id, 'destroying'));

	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/destroy`, {}, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(setClusterOptimisticState(id, 'available'));
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

// Recycle step 1: mark the cluster for recycling, then destroy it (the scheduler
// redeploys after destroy completes). Uses the cluster-scoped endpoint (cluster:update)
// so organization admins can recycle, instead of the developer-only /api/dev/cluster-action
// (developer:access), which returns 403 for org-scoped users.
export const setClusterRecyclingFlag = id => dispatch => {
	return axios.post(`${API_BASE_URL}/api/clusters/${id}/recycling-flag`, {}, headers);
};


export const forceDestroyCluster = (id, resetingState) => dispatch => {
	dispatch(showMessage({ message: 'Force Cluster Destroy Initiated' }));
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/destroy`, { resetingState }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const toggleDestroyLock = (id, isLocked) => dispatch => {
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${id}/destroy-lock`,
		{ isLocked },
		headers
	);
	return request
		.then(response => {
			dispatch(getCluster({ id }));
			return response;
		})
		.catch(err => {
			throw err;
		});
};

export const toggleAutoUpdate = (id, enabled) => dispatch => {
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${id}/auto-update`,
		{ enabled },
		headers
	);
	return request
		.then(response => {
			dispatch(getCluster({ id }));
			return response;
		})
		.catch(err => {
			throw err;
		});
};

export const toggleIdleAutoStop = (id, enabled) => dispatch => {
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${id}/idle-auto-stop`,
		{ enabled },
		headers
	);
	return request
		.then(response => {
			dispatch(getCluster({ id }));
			return response;
		})
		.catch(err => {
			throw err;
		});
};

/**
 * Configure cluster-idle teardown: stop or destroy this cluster once nobody is
 * using it. `settings` is { enabled, action, minutes, unit }; the API
 * normalises it again and owns every runtime field.
 */
export const setIdleTeardown = (id, settings) => dispatch => {
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${id}/idle-teardown`,
		settings,
		headers
	);
	return request
		.then(response => {
			dispatch(getCluster({ id }));
			return response;
		})
		.catch(err => {
			throw err;
		});
};

/**
 * Ask what is keeping this cluster awake right now. Probes the cluster live
 * rather than reading the last stored sample - the person asking is looking at
 * the screen wondering why their cluster did or did not shut down.
 */
export const fetchClusterActivity = (id) => () => {
	return axios
		.get(`${API_BASE_URL}/api/clusters/${id}/activity`, headers)
		.then(response => response.data);
};

export const updateClusterApplications = (id, applications) => dispatch => {
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${id}/applications`,
		{ applications },
		headers
	);
	return request
		.then(response => {
			dispatch(getCluster({ id }));
			return response;
		})
		.catch(err => {
			throw err;
		});
};

export const deployNode = (cluster, nodes) => dispatch => {
	dispatch(showMessage({ message: 'Node Deploy Initiated' }));
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/${cluster}/deployNode`, { nodes }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const destroyNode = (cluster, nodes) => dispatch => {
	dispatch(showMessage({ message: 'Node Destroy Initiated' }));
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/${cluster}/destroyNode`, { nodes }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const disks = (id, disks) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(showMessage({ message: 'Add Disks Initiated' }));
	const request = axios.post(`${API_BASE_URL}/api/clusters/add-disk`, { id, disks }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const resize = (id, size) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	dispatch(showMessage({ message: 'Cluster Resize Initiated' }));
	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/resize`, { size }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

export const burst = (cluster, mode, callback) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.put(
		`${API_BASE_URL}/api/clusters/${cluster}/burst/mode`,
		{ mode },
		headers
	);
	return request
		.then(() => {
			dispatch(ActionsDialog.toggleLoading());
			if (callback && typeof callback === 'function') {
				callback();
			}
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			const { code, message } = err.data;
			if (code !== 500) dispatch(showMessage({ message, variant: 'error' }));
			else dispatch(showMessage({ message: 'Something went wrong while attempting to change the burst mode', variant: 'error' }));
		});
};

export const toggleOpenvpn = ({ cluster, openvpn }) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/openvpn`, { cluster, openvpn }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// VNC ////////////// * //

const generateToken = (cluster, username) => {
	const hash = CryptoJS.SHA256(`${cluster}-${username}`);
	return hash.toString(CryptoJS.enc.Hex);
};

export const setClusterTokenAction = (cluster, username) => async dispatch => {
	const token = generateToken(cluster, username);
	dispatch(setClusterToken(token));
	return token;
};

export const manageFastSnapshotRestore = (id, action) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	const request = axios.post(`${API_BASE_URL}/api/clusters/${id}/managefsr`, { action }, headers);
	return request
		.then(() => dispatch(ActionsDialog.toggleLoading()))
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
		});
};

// * ////////////// SSH KEY UPLOAD ////////////// * //
export const uploadSSHKey = (clusterId, file, targetUsername) => dispatch => {
	dispatch(ActionsDialog.toggleLoading());
	
	const formData = new FormData();
	formData.append('sshKey', file);
	formData.append('targetUsername', targetUsername);
	
	const request = axios.post(`${API_BASE_URL}/api/clusters/${clusterId}/upload-ssh-key`, formData, {
		headers: {
			'Content-Type': 'multipart/form-data'
		}
	});
	
	return request
		.then(response => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(showMessage({ message: 'SSH key uploaded successfully', variant: 'success' }));
			return response;
		})
		.catch(err => {
			dispatch(ActionsDialog.toggleLoading());
			dispatch(setClusterError({ ...err.data, type: 'modal' }));
			dispatch(showMessage({ message: 'Failed to upload SSH key', variant: 'error' }));
			throw err;
			});
};

// * ////////////// AI TERRAFORM ERROR ANALYSIS ////////////// * //

/**
 * Utility function to extract the first Terraform error block from HTML logs
 * Specifically looks for lines starting with "│ Error:" and extracts that line plus 4 following lines
 * @param {string} logs - The complete log string (HTML formatted)
 * @returns {string|null} - The first Terraform error block or null if not found
 */
const extractFirstTerraformError = (logs) => {
	if (!logs || typeof logs !== 'string') {
		return null;
	}

	// First, clean up HTML tags and decode HTML entities
	let cleanLogs = logs
		.replace(/<br\s*\/?>/gi, '\n')  // Replace <br> tags with newlines
		.replace(/<[^>]*>/g, '')        // Remove all HTML tags
		.replace(/&lt;/g, '<')          // Decode HTML entities
		.replace(/&gt;/g, '>')
		.replace(/&amp;/g, '&')
		.replace(/&quot;/g, '"')
		.replace(/&#39;/g, "'")
		.replace(/&nbsp;/g, ' ');

	// Split into lines and look for Terraform error pattern
	const lines = cleanLogs.split('\n');
	
	// Find the first line that starts with "│ Error:"
	for (let i = 0; i < lines.length; i++) {
		const line = lines[i].trim();
		if (line.startsWith('│ Error:')) {
			// Found the error line, extract it plus the next 4 lines
			const errorLines = [];
			for (let j = i; j < Math.min(i + 5, lines.length); j++) {
				const currentLine = lines[j].trim();
				if (currentLine) { // Only include non-empty lines
					errorLines.push(currentLine);
				}
			}
			
			if (errorLines.length > 0) {
				return errorLines.join('\n');
			}
		}
	}

	// Fallback: look for any line starting with "Error:" (without │)
	for (let i = 0; i < lines.length; i++) {
		const line = lines[i].trim();
		if (line.startsWith('Error:')) {
			// Found the error line, extract it plus the next 4 lines
			const errorLines = [];
			for (let j = i; j < Math.min(i + 5, lines.length); j++) {
				const currentLine = lines[j].trim();
				if (currentLine) { // Only include non-empty lines
					errorLines.push(currentLine);
				}
			}
			
			if (errorLines.length > 0) {
				return errorLines.join('\n');
			}
		}
	}

	return null;
};

/**
 * Generate a simple hash of logs content to detect changes
 * @param {string} logs - The logs content
 * @returns {string} Hash of the logs
 */
const generateLogsHash = (logs) => {
	if (!logs) return '';
	let hash = 0;
	for (let i = 0; i < logs.length; i++) {
		const char = logs.charCodeAt(i);
		hash = ((hash << 5) - hash) + char;
		hash = hash & hash; 
	}
	return hash.toString();
};

/**
 * Check if we have cached AI analysis for this cluster with these logs
 * @param {string} clusterId - The cluster ID
 * @param {string} logs - The current logs content
 * @returns {Object|null} Cached analysis if valid, null if not found or outdated
 */
const getCachedAiAnalysis = (clusterId, logs) => {
	try {
		const cacheKey = `ai_analysis_${clusterId}`;
		const cached = localStorage.getItem(cacheKey);
		
		if (!cached) return null;
		
		const analysisData = JSON.parse(cached);
		const currentLogsHash = generateLogsHash(logs);
		
		// Check if logs have changed
		if (analysisData.logsHash !== currentLogsHash) {
			// Remove outdated cache
			localStorage.removeItem(cacheKey);
			return null;
		}
		
		// Check if cache is not too old (optional - 24 hours)
		const cacheAge = Date.now() - new Date(analysisData.timestamp).getTime();
		const maxCacheAge = 24 * 60 * 60 * 1000; // 24 hours
		
		if (cacheAge > maxCacheAge) {
			localStorage.removeItem(cacheKey);
			return null;
		}
		
		return analysisData;
	} catch (err) {
		console.warn(err);
		return null;
	}
};

/**
 * Action to analyze Terraform errors using AI inference
 * @param {string} clusterId - The cluster ID
 * @param {string} logs - The cluster logs containing Terraform errors
 */
export const analyzeTerraformError = (clusterId, logs) => dispatch => {
	// Check cache first
	const cachedAnalysis = getCachedAiAnalysis(clusterId, logs);
	if (cachedAnalysis) {
		dispatch(setAiErrorAnalysis(cachedAnalysis));
		return Promise.resolve(cachedAnalysis.analysis);
	}

	const terraformError = extractFirstTerraformError(logs);
	
	if (!terraformError) {
		return Promise.resolve(null);
	}


	// Use axios with existing authentication interceptors
	const request = axios.post(`${API_BASE_URL}/api/ai/inference/terraform_error`, {
		prompt: terraformError,
		max_tokens: 100
	}, {
		timeout: 150000  // 2.5 minutes to handle slow AI responses
	});

	return request
		.then(response => {
			
			const analysisData = {
				clusterId,
				error: terraformError,
				analysis: response.data,
				timestamp: new Date().toISOString(),
				logsHash: generateLogsHash(logs) // Hash of the logs to detect changes
			};
			
			dispatch(setAiErrorAnalysis(analysisData));
			
			// Cache in localStorage for persistence across sessions
			try {
				const cacheKey = `ai_analysis_${clusterId}`;
				localStorage.setItem(cacheKey, JSON.stringify(analysisData));
			} catch (err) {
				console.warn(err);
			}
			
			return response.data;
		})
		.catch(err => {
			console.error(err);
			return null;
		});
};

/**
 * Clean up old AI analysis cache entries (optional - run periodically)
 */
export const cleanupAiAnalysisCache = () => {
	try {
		const maxCacheAge = 10 * 24 * 60 * 60 * 1000; // 10 days
		const keysToRemove = [];
		
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);
			if (key && key.startsWith('ai_analysis_')) {
				try {
					const cached = localStorage.getItem(key);
					const analysisData = JSON.parse(cached);
					const cacheAge = Date.now() - new Date(analysisData.timestamp).getTime();
					
					if (cacheAge > maxCacheAge) {
						keysToRemove.push(key);
					}
				} catch (err) {
					// If can't parse it, remove it
					keysToRemove.push(key);
				}
			}
		}
		
		keysToRemove.forEach(key => {
			localStorage.removeItem(key);
		});
		
	} catch (err) {
		console.warn(err);
	}
};

/**
 * Load cached AI analysis for a cluster if available and valid
 * @param {string} clusterId - The cluster ID
 * @param {string} logs - The current logs content
 */
export const loadCachedAiAnalysis = (clusterId, logs) => dispatch => {
	const cachedAnalysis = getCachedAiAnalysis(clusterId, logs);
	if (cachedAnalysis) {
		dispatch(setAiErrorAnalysis(cachedAnalysis));
		return Promise.resolve(cachedAnalysis);
	}
	return Promise.resolve(null);
};

/**
 * Enhanced cluster state monitoring that triggers AI analysis on failure
 * This function should be called when cluster state changes are detected
 */
export const handleClusterStateChange = (previousCluster, currentCluster) => dispatch => {
	// Check if cluster just changed to failed state
	const previousState = previousCluster?.info?.state;
	const currentState = currentCluster?.info?.state;
	
	if (previousState !== 'failed' && currentState === 'failed') {
		
		// Get logs and analyze Terraform errors
		dispatch(getLogs({ id: currentCluster.id, type: 'deploy' }))
			.then(() => {
				// Get logs from store after they're loaded
				const logs = store.getState()?.clusters?.cluster?.logs;
				if (logs) {
					dispatch(analyzeTerraformError(currentCluster.id, logs));
				}
			})
			.catch(err => {
				console.error(err);
			});
	}
};

// * ////////////// STORAGE PROVIDERS ////////////// * //

export const SET_STORAGE_PROVIDERS = 'SET_STORAGE_PROVIDERS';
export const SET_STORAGE_PROVIDERS_LOADING = 'SET_STORAGE_PROVIDERS_LOADING';
export const SET_STORAGE_PROVIDERS_ERROR = 'SET_STORAGE_PROVIDERS_ERROR';
export const CLEAR_STORAGE_PROVIDERS = 'CLEAR_STORAGE_PROVIDERS';

export const setStorageProvidersLoading = (loading) => ({
	type: SET_STORAGE_PROVIDERS_LOADING,
	payload: loading
});

export const setStorageProviders = providers => ({
	type: SET_STORAGE_PROVIDERS,
	payload: providers
});

export const setStorageProvidersError = error => ({
	type: SET_STORAGE_PROVIDERS_ERROR,
	payload: error
});

// * ////////////// STRESS TESTS ////////////// * //

export const executeStressTest = (clusterId, testConfig) => async dispatch => {
	dispatch(setStressTestLoading(true));
	dispatch(setStressTestError(null));

	try {
		const response = await axios.post(`${API_BASE_URL}/api/stress-tests/${clusterId}/execute`, testConfig, { headers: { admin: true } });
		
		dispatch(setStressTestData(response.data));
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to execute stress test';
		dispatch(setStressTestError(errorMessage));
		throw error;
	} finally {
		dispatch(setStressTestLoading(false));
	}
};

export const runGpuStressTest = (clusterId, testConfig) => async dispatch => {
	dispatch(setStressTestLoading(true));
	dispatch(setStressTestError(null));

	try {

		// Use the same stress test endpoint but with GPU-specific configuration
		const gpuTestConfig = {
			...testConfig,
			testType: 'gpu',
			category: 'gpu',
			clusterId // Make sure clusterId is included
		};

		const response = await axios.post(`${API_BASE_URL}/api/stress-tests/${clusterId}/execute`, gpuTestConfig, { 
			headers: { admin: true } 
		});
				
		dispatch(setStressTestData(response.data));
		
		// Start polling for results after a delay
		setTimeout(() => {
			dispatch(fetchGpuStressTestHistory(clusterId));
		}, 5000);
		
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to execute GPU stress test';
		console.error('GPU stress test error:', errorMessage);
		dispatch(setStressTestError(errorMessage));
		throw error;
	} finally {
		dispatch(setStressTestLoading(false));
	}
};

export const fetchStressTestHistory = (clusterId, options = {}) => async dispatch => {
	dispatch(setStressTestLoading(true));
	dispatch(setStressTestError(null));

	try {
		const params = new URLSearchParams();
		if (options.nodes) params.append('nodes', options.nodes.join(','));
		if (options.testType) params.append('testType', options.testType);
		if (options.volume) params.append('volume', options.volume);
		if (options.limit) params.append('limit', options.limit);

		const response = await axios.get(`${API_BASE_URL}/api/stress-tests/${clusterId}/history?${params.toString()}`, { headers: { admin: true } });
		
		dispatch(setStressTestHistory(response.data));
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch stress test history';
		dispatch(setStressTestError(errorMessage));
		throw error;
	} finally {
		dispatch(setStressTestLoading(false));
	}
};

export const fetchNodeVolumes = (clusterId, hostname, options = {}) => async dispatch => {
	
	try {
		const params = new URLSearchParams();
		if (options.testType) params.append('testType', options.testType);

		// Use the existing cluster volumes endpoint
		const response = await axios.get(`${API_BASE_URL}/api/stress-tests/${clusterId}/volumes?${params.toString()}`, { headers: { admin: true } });
		
		// Extract the volumesByNode data and filter by hostname
		const volumesData = response.data?.data || response.data;
		const nodeVolumes = volumesData?.volumesByNode?.[hostname]?.volumes || [];
		
		return nodeVolumes;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch node volumes';
		console.error('Error fetching node volumes:', errorMessage);
		throw error;
	}
};

export const checkStressTestResults = (clusterId, options = {}) => async dispatch => {
	try {
		const params = new URLSearchParams();
		if (options.nodes) params.append('nodes', options.nodes.join(','));
		if (options.since) params.append('since', options.since);

		const response = await axios.get(`${API_BASE_URL}/api/stress-tests/${clusterId}/status?${params.toString()}`, { headers: { admin: true } });
		
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to check stress test results';
		console.error('Error checking stress test results:', errorMessage);
		throw error;
	}
};

export const fetchClusterVolumes = (clusterId) => async dispatch => {
	dispatch(setStressTestLoading(true));
	dispatch(setStressTestError(null));

	try {
		const response = await axios.get(`${API_BASE_URL}/api/stress-tests/${clusterId}/volumes`, { headers: { admin: true } });
		
		// Extract the volumesByNode data from the nested response
		const volumesData = response.data?.data || response.data;
		dispatch(setClusterVolumes(volumesData));
		return volumesData;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch cluster volumes';
		dispatch(setStressTestError(errorMessage));
		throw error;
	} finally {
		dispatch(setStressTestLoading(false));
	}
};

export const clearStressTestData = () => dispatch => {
	dispatch(setStressTestData(null));
	dispatch(setStressTestError(null));
	dispatch(setStressTestHistory(null));
	dispatch(setClusterVolumes(null));
};

export const clearStorageProviders = () => ({
	type: CLEAR_STORAGE_PROVIDERS
});

export const getStorageProviders = () => {
	return (dispatch) => {
		dispatch(setStorageProvidersLoading(true));
		
		const request = axios.get(`${API_BASE_URL}/api/storage-providers`, headers);
	
		return request
			.then(response => {
				dispatch(setStorageProviders(response.data || []));
				return response.data;
			})
			.catch(err => {
				console.error('Error fetching storage providers:', err);
				const errorMessage = (err.response && err.response.data && err.response.data.error) || 
							   (err.response && err.response.data && err.response.data.message) || 
							   err.message || 
							   'Failed to fetch storage providers';
				dispatch(setStorageProvidersError(errorMessage));
				throw err;
			})
			.finally(() => {
				dispatch(setStorageProvidersLoading(false));
			});
	};
};

// GPU-specific stress test actions
export const fetchGpuStressTestHistory = (clusterId, options = {}) => async dispatch => {
	return dispatch(fetchStressTestHistory(clusterId, { ...options, testType: 'gpu' }));
};

export const stopGpuStressTest = (clusterId, nodeHostname) => async dispatch => {
	dispatch(setStressTestLoading(true));
	dispatch(setStressTestError(null));

	try {
		const response = await axios.post(`${API_BASE_URL}/api/stress-tests/${clusterId}/stop`, {
			nodes: [nodeHostname],
			testType: 'gpu'
		}, { headers: { admin: true } });
		
		
		// Refresh test data after stopping
		setTimeout(() => {
			dispatch(fetchGpuStressTestHistory(clusterId));
		}, 1000);
		
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message || 'Failed to stop GPU stress test';
		console.error('Stop GPU test error:', errorMessage);
		dispatch(setStressTestError(errorMessage));
		throw error;
	} finally {
		dispatch(setStressTestLoading(false));
	}
};

// * ////////////// VOLUMEZ POLICY MANAGEMENT ////////////// * //

export const SET_PROVIDER_POLICIES = 'SET_PROVIDER_POLICIES';
export const SET_PROVIDER_POLICIES_LOADING = 'SET_PROVIDER_POLICIES_LOADING';
export const SET_PROVIDER_POLICIES_ERROR = 'SET_PROVIDER_POLICIES_ERROR';
export const SET_SELECTED_POLICY = 'SET_SELECTED_POLICY';
export const SET_POLICY_CONSTRAINTS = 'SET_POLICY_CONSTRAINTS';
export const SET_POLICY_CONSTRAINTS_LOADING = 'SET_POLICY_CONSTRAINTS_LOADING';
export const SET_POLICY_CONSTRAINTS_ERROR = 'SET_POLICY_CONSTRAINTS_ERROR';
export const SET_CONFIGURATION_VALIDATION = 'SET_CONFIGURATION_VALIDATION';
export const SET_CONFIGURATION_VALIDATION_LOADING = 'SET_CONFIGURATION_VALIDATION_LOADING';
export const RESET_POLICY_VALIDATION = 'RESET_POLICY_VALIDATION';

// Action creators for provider policies
export const setProviderPolicies = (providerId, policies) => ({
	type: SET_PROVIDER_POLICIES,
	payload: { providerId, policies }
});

export const setProviderPoliciesLoading = (providerId, loading) => ({
	type: SET_PROVIDER_POLICIES_LOADING,
	payload: { providerId, loading }
});

export const setProviderPoliciesError = (providerId, error) => ({
	type: SET_PROVIDER_POLICIES_ERROR,
	payload: { providerId, error }
});

export const setSelectedPolicy = (providerId, policyName) => ({
	type: SET_SELECTED_POLICY,
	payload: { providerId, policyName }
});

export const setPolicyConstraints = (providerId, policyName, constraints) => ({
	type: SET_POLICY_CONSTRAINTS,
	payload: { providerId, policyName, constraints }
});

export const setPolicyConstraintsLoading = (providerId, policyName, loading) => ({
	type: SET_POLICY_CONSTRAINTS_LOADING,
	payload: { providerId, policyName, loading }
});

export const setPolicyConstraintsError = (providerId, policyName, error) => ({
	type: SET_POLICY_CONSTRAINTS_ERROR,
	payload: { providerId, policyName, error }
});

export const setConfigurationValidation = (providerId, validationResult) => ({
	type: SET_CONFIGURATION_VALIDATION,
	payload: { providerId, validationResult }
});

export const setConfigurationValidationLoading = (providerId, loading) => ({
	type: SET_CONFIGURATION_VALIDATION_LOADING,
	payload: { providerId, loading }
});

export const resetPolicyValidation = (providerId) => ({
	type: RESET_POLICY_VALIDATION,
	payload: { providerId }
});

// Thunk actions for fetching provider policies with allowedConfigurations
export const fetchStorageProviderPolicies = (providerId) => {
	return async (dispatch) => {
		dispatch(setProviderPoliciesLoading(providerId, true));
		dispatch(setProviderPoliciesError(providerId, null));
		
		try {
			const response = await axios.get(`${API_BASE_URL}/api/providers/${providerId}/policies`, {
				headers: { admin: true }
			});
			
			if (response.data.success) {
				dispatch(setProviderPolicies(providerId, response.data.data.policies));
				return response.data.data.policies;
			} else {
				throw new Error(response.data.error || 'Failed to fetch policies');
			}
		} catch (error) {
			const errorMessage = error.response?.data?.error || 
							   error.response?.data?.message || 
							   error.message || 
							   'Failed to fetch storage provider policies';
			dispatch(setProviderPoliciesError(providerId, errorMessage));
			throw error;
		} finally {
			dispatch(setProviderPoliciesLoading(providerId, false));
		}
	};
};

// Select a policy and fetch its constraints if it's a profile policy
export const selectVolumePolicy = (providerId, policyName) => {
	return async (dispatch) => {
		dispatch(setSelectedPolicy(providerId, policyName));
		
		// Note: Policy constraints are now loaded via fetchStorageProviderPolicies
		// No need for separate constraint fetching since all policy data is available
	};
};

// Fetch policy constraints for a specific profile type
// DEPRECATED: fetchPolicyConstraints - policy constraints are now loaded via fetchStorageProviderPolicies
// export const fetchPolicyConstraints = (providerId, policyName) => {
//   Policy constraints are now embedded in the provider policies data structure
//   Use selectPolicyConstraintsByProviderAndPolicy selector instead
// };

// ─── Feature: cluster-app-proxy ────────────────────────────────────────────

/**
 * Launch a proxied web application on a cluster
 * @param {Object} config - { clusterId, appId, appName, command, port, basePath, env, singularityImage, containerBinds, singleInstance, openPath }
 *   openPath is optional and Jupyter-only: a path under $HOME to open on arrival,
 *   which is how a document in Heidi Documents opens as itself rather than as a
 *   file browser the user then has to navigate.
 * @returns {Object} - { proxyToken, url, status, appName, port, pid, createdAt, expiresAt }
 */
export const launchProxiedApp = (config) => {
	return async (dispatch) => {
		try {
			const response = await axios.post(`${API_BASE_URL}/api/app-proxy/launch`, config);
			if (response.data) {
				dispatch(showMessage({ message: `${config.appName || config.appId} launched successfully` }));
				return response.data;
			}
		} catch (error) {
			// errorResponse: the interceptor rejects with the response itself, so
			// reading only error.response dropped the server's explanation.
			const errorData = errorResponse(error).data || {};
			const errorMessage = errorData.message || errorData.details || error.message || 'Failed to launch application';
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
			throw error;
		}
	};
};

/**
 * Get active proxied app sessions for a cluster
 * @param {string} clusterId - Cluster ID
 * @returns {Object} - { sessions: [...] }
 */
export const getProxiedAppSessions = (clusterId) => {
	return async () => {
		try {
			const response = await axios.get(`${API_BASE_URL}/api/app-proxy/sessions`, {
				params: { clusterId }
			});
			return response.data;
		} catch (error) {
			console.error('Failed to fetch proxied app sessions:', error);
			return { sessions: [] };
		}
	};
};

/**
 * Stop a proxied web application
 * @param {string} proxyToken - The proxy session token
 */
export const stopProxiedApp = (proxyToken) => {
	return async (dispatch) => {
		try {
			const response = await axios.delete(`${API_BASE_URL}/api/app-proxy/sessions/${proxyToken}`);
			if (response.data) {
				dispatch(showMessage({ message: 'Application stopped' }));
				return response.data;
			}
		} catch (error) {
			const errorMessage = error.response?.data?.message || error.message || 'Failed to stop application';
			dispatch(showMessage({ message: errorMessage, variant: 'error' }));
			throw error;
		}
	};
};

// Validate a configuration against policy constraints
export const validateConfiguration = (providerId, configData) => {
	return async (dispatch) => {
		dispatch(setConfigurationValidationLoading(providerId, true));
		
		try {
			const response = await axios.post(`${API_BASE_URL}/api/providers/${providerId}/configurations/validate`, configData, {
				headers: { admin: true }
			});
			
			if (response.data.success) {
				dispatch(setConfigurationValidation(providerId, response.data.data));
				return response.data.data;
			} else {
				throw new Error(response.data.error || 'Configuration validation failed');
			}
		} catch (error) {
			const errorMessage = error.response?.data?.error || 
							   error.response?.data?.message || 
							   error.message || 
							   'Configuration validation failed';
			
			// Set validation result with error
			dispatch(setConfigurationValidation(providerId, {
				valid: false,
				error: errorMessage
			}));
			throw error;
		} finally {
			dispatch(setConfigurationValidationLoading(providerId, false));
		}
	};
};
// * ////////////// GLOBUS DATA TRANSFER ////////////// * //

/**
 * Globus data transfer on a cluster head node (feature: heidi-globus).
 *
 * The collection belongs to the customer's own Globus account, so these calls
 * only install the endpoint software and hand over a setup key the user created
 * there. The key is single-use: it goes straight to the API and is never kept
 * here, in the store, or on the cluster document.
 *
 * All four resolve with the API payload and let the caller render the failure,
 * because the interesting failures (Globus rejected the key, the head node is
 * unreachable) are the ones the user has to read verbatim to act on.
 */
export const fetchGlobusStatus = (clusterId) => async () => {
	try {
		// skipForbiddenToast: cluster:globus-read is the owner's, an org admin's
		// and an org instructor's, so anyone else looking at a cluster - a
		// workshop participant, a platform user the cluster is merely shared
		// with - legitimately 403s here. Swallowing it in the catch below is too
		// late: the global response interceptor has already fired its red
		// "Forbidden" toast by then, on a page where nothing is actually wrong.
		const response = await axios.get(`${API_BASE_URL}/api/globus/${clusterId}/status`, {
			skipForbiddenToast: true
		});
		return response.data;
	} catch (error) {
		// A cluster with no endpoint, or one that is stopped, is not an error
		// worth a snackbar - the card renders the "not set up" state instead.
		if (error.response && (error.response.status === 403 || error.response.status === 404)) {
			return null;
		}
		console.error('Error fetching Globus status:', error);
		return null;
	}
};

export const installGlobusEndpoint = (clusterId, settings = {}) => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/globus/${clusterId}/install`, settings);
	return response.data;
};

export const registerGlobusEndpoint = (clusterId, setupKey) => async () => {
	const response = await axios.post(`${API_BASE_URL}/api/globus/${clusterId}/register`, { setupKey });
	return response.data;
};

export const removeGlobusEndpoint = (clusterId) => async () => {
	const response = await axios.delete(`${API_BASE_URL}/api/globus/${clusterId}`);
	return response.data;
};

// * ////////////// ORGANIZATION TRANSFER ////////////// * //
// Feature: cluster-org-transfer. Platform super-admins only - the API enforces
// it, these just drive the dialog.

/**
 * Users eligible to own the cluster once it lands in `organizationId`
 * (null / omitted = the platform level).
 */
export const getClusterTransferOwners = (clusterId, organizationId) => async () => {
	const query = organizationId ? `?organizationId=${organizationId}` : '';
	const response = await axios.get(
		`${API_BASE_URL}/api/clusters/${clusterId}/transfer-owners${query}`,
		headers
	);
	return response.data.owners || [];
};

/**
 * Move the cluster to another organization, or out to the platform level.
 * Resolves with the API's summary of what moved; rejects so the dialog can show
 * the reason a transfer was refused (busy cluster, ineligible owner, credential
 * still in use) rather than swallowing it into a snackbar.
 */
export const transferClusterOrganization = (clusterId, payload) => async dispatch => {
	const response = await axios.put(
		`${API_BASE_URL}/api/clusters/${clusterId}/organization`,
		payload,
		headers
	);
	dispatch(getClusters());
	return response.data;
};
